export default __webpack_public_path__ + "static/media/Bengals.68eeec33.png";